import { render, staticRenderFns } from "./ManteConfiguracion.vue?vue&type=template&id=48f25820&"
import script from "./ManteConfiguracion.vue?vue&type=script&lang=js&"
export * from "./ManteConfiguracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports